<ng-container *ngIf="nav$ | async let nav">
  <div class="main h-100 w-100 d-flex flex-column justify-content-start" style="overflow: hidden !important;">

      <div class="content flex-fill h-100">
          <div class="container flex-fill d-flex flex-column h-100">

              <div class="header" fadeIn="500" [fadeInDelay]="200">
                  <div class="tabs d-flex align-items-center justify-content-center tabs-pos">
                      <app-tabs
                          linePosition="bottom"
                          alignment="start"
                          [tabs]="tabs"
                          [activeTab]="nav.tab!"
                          (onTabSelect)="onTabSelected($event)"
                      ></app-tabs>
                  </div>

                  <div class="date-legend d-flex align-items-center justify-content-between">
                      <app-date-range class="date-range-picker"
                                      [selected]="(dateFilter$ | async)"
                                      (change)="selectedRangeChange($event)"
                      >
                      </app-date-range>
                      <div class="cc-legend-wrapper" *ngIf="['Pre-chargebacks', 'Chargebacks'].includes(nav.tab)">
                          <ng-container *ngIf="nav.tab === 'Pre-chargebacks'">
                              <div class="cc-legend">
                                  <div class="legend-dot pre-chargeback"></div>
                                  <div class="legend-label">Pre-charge backed</div>
                              </div>
                              <div class="cc-legend">
                                  <div class="legend-dot arbitration"></div>
                                  <div class="legend-label">Arbitration</div>
                              </div>
                          </ng-container>
                          <ng-container *ngIf="nav.tab === 'Chargebacks'">
                              <div class="cc-legend">
                                  <div class="legend-dot chargeback"></div>
                                  <div class="legend-label">Charged-back</div>
                              </div>
                              <div class="cc-legend">
                                  <div class="legend-dot resolved"></div>
                                  <div class="legend-label">Resolved</div>
                              </div>
                          </ng-container>
                      </div>
                  </div>
              </div>
              <ng-container *ngIf="report$ | async let report">
                  <div class="w-100 h-100 d-flex align-items-center justify-content-center" *ngIf="!report">
                      <mat-spinner class="m-auto" [diameter]="40"></mat-spinner>
                  </div>
                  <ng-container *ngIf="report">
                      <app-sales-summary [selectedTab]="getSelectedTab(nav.tab)" [data]="report" fadeIn="500" [fadeInDelay]="200"></app-sales-summary>
                      <div class="items-count-wrapper"
                          [class.count-hidden]="loading$ | async"
                      >
                          <div class="d-flex align-items-center">
                              <div class="items-count-container">
                                  <h4 class="items-count" *ngIf="report.count">{{ report.count }} Item{{ report.count > 1 ? 's' : null }}</h4>
                              </div>
                          </div>
                      </div>
                      <app-credit-card-report-items [current]="$any(nav.tab)" class="flex-fill" fadeIn="500" [fadeInDelay]="200"></app-credit-card-report-items>
                  </ng-container>
              </ng-container>
          </div>
      </div>
  </div>
</ng-container>
